import Tooltip from '@katalon-studio/katalon-ui/Tooltip';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { ReactComponent as DocumentIcon } from '../../icons/DocumentIcon.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconContainer: {
    width: theme.spacing(2.5),
  },
  icon: {
    display: 'flex',
  },
  button: {
    width: `${theme.spacing(5)} !important`,
    backgroundColor: 'transparent',
    minWidth: 'unset',
    height: theme.spacing(5),
    padding: 0,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
    },
  },
}));

const KATALON_DOCS_URL = 'https://docs.katalon.com/';

export const DocumentationMenu = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div id="layout.header.documentation" className={classes.root}>
      <Tooltip
        label={intl.formatMessage({ id: 'layout.header.documentation.tooltip' })}
        placement="bottom"
        size="medium"
        TransitionProps={{ timeout: 0 }}
      >
        <Button
          size="small"
          variant="contained"
          component={RouterLink}
          to={KATALON_DOCS_URL}
          className={classes.button}
          target="_blank"
        >
          <div className={classes.iconContainer}>
            <DocumentIcon className={classes.icon} />
          </div>
        </Button>
      </Tooltip>
    </div>
  );
};
